import IconGoogle from '@/assets/google-full.svg?react';
import IconGoogleColor from '@/assets/google-full-color.svg?react';
import Padlock from '@/assets/padlock.svg?react';
import Stars from '@/components/ui/Stars';
import cn from '@/utils/cn';

import { Trans } from '@lingui/react';

export type Google = {
  count: number;
  rate: number | string;
};

interface BadgeProps {
  variant: 'color' | 'gray' | 'padlock';
  google?: Google;
  className?: string;
}

const rateMax = 5;

const Badge: React.FC<BadgeProps> = ({
  variant,
  className,
  google = {
    count: 0,
    rate: 0,
  },
}) => {
  const googleRateNumber = Number(google.rate);
  return (
    <div
      className={cn(
        'flex w-full max-w-full items-center justify-center gap-1.5 rounded-md py-1.5',
        variant === 'padlock' ? 'bg-gray-100 px-4' : 'bg-gray-200',
        className
      )}
    >
      {variant !== 'padlock' && (
        <>
          {variant === 'color' ? (
            <IconGoogleColor width={50} height={16} />
          ) : (
            <IconGoogle width={50} height={16} />
          )}
          <Stars
            fill={googleRateNumber <= rateMax ? googleRateNumber : rateMax}
            size={14}
            keyProp={'google'}
            rateMax={rateMax}
          />
          <p className={'caption-small text-dark-gray-500'}>
            {(googleRateNumber <= rateMax ? googleRateNumber : rateMax)
              .toFixed(1)
              .toString()
              .replaceAll('.', ',')}
            /{google.count} <Trans id={'opinii'}>opinii</Trans>
          </p>
        </>
      )}
      {variant === 'padlock' && (
        <>
          <Padlock width={12} className="text-primary" />
          <p className={'caption-small text-dark-gray-500'}>
            <Trans id={'Twoje dane są u nas bezpieczne'}>
              Twoje dane są u nas bezpieczne
            </Trans>
          </p>
        </>
      )}
    </div>
  );
};

export default Badge;
